const extractNumberFromString = (text) => {
  if (text) {
    const getNumberRegEx = /\d+(\.\d+)?(,\d+)?/;
    const extractedNumberArr = text.match(getNumberRegEx);
    const result = extractedNumberArr ? extractedNumberArr[0] : null;
    return result;
  }
  return null;
};
export default extractNumberFromString;
